/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchUserLoginHistoryResponseItem } from './search-user-login-history-response-item';


export interface SearchUserLoginHistoryResponseItemPagedList { 
    totalCount?: number;
    items?: Array<SearchUserLoginHistoryResponseItem> | null;
}

